// extracted by mini-css-extract-plugin
export var button = "dashboard-bar-module--button--179ef";
export var container = "dashboard-bar-module--container--2d2ff";
export var title = "dashboard-bar-module--title--6d618";